import { loginAccount_loginAccount_required_next_step } from '../generated-types/loginAccount';

export interface PreferredLoginProps {
  sign_in_method?: string | null;
  avatar_url?: string | null;
  email: string | null;
}

export type TwoFactorAuthType = 'authenticator' | 'sms' | 'recovery_codes';

export type LoginStatus = 'granted' | 'pending' | 'rejected';

export type DeviceVerificationLoginStep = {
  type: 'device_verification';
  primary: never;
  secondary: never;
};

export type TwoFactorAuthLoginStep = {
  type: 'two_factor_auth';
  primary: TwoFactorAuthType;
  secondary: TwoFactorAuthType;
};

export type LoginStep = TwoFactorAuthLoginStep | DeviceVerificationLoginStep;

export function isTwoFactorAuthType(value: string | null): value is TwoFactorAuthType {
  return !!value && ['authenticator', 'sms', 'recovery_codes'].includes(value);
}

export function isLoginStep(data: loginAccount_loginAccount_required_next_step | null | undefined): data is LoginStep {
  if (!data) {
    return false;
  }

  return (
    (data.type === 'device_verification' && !data.primary && !data.secondary) ||
    (data.type === 'two_factor_auth' && isTwoFactorAuthType(data.primary))
  );
}
